<template>
 <div class="w-full  my-2 flex flex-col space-y-3 border border-warmGray-300 shadow-sm">
                    <!---========-->
                    <div class="flex px-4 py-3 shadow-sm">
                    <p class="w-3/4 my-auto text-warmGray-600 font-semibold ">Zwischensumme: </p>
                    <p class="m-auto">{{ numeralFormat(cartTotal, '0,00[.]00 $') }} </p>

                    </div>
                    <!---========-->
                      <div class="flex   px-4 py-3 shadow-sm">
                    <p class="w-3/4 my-auto text-warmGray-600 font-semibold ">Lieferkosten: </p>
                    <p class="m-auto">{{ numeralFormat(lieferKosten, '0,00[.]00 $') }} </p>
                    <!-- <p class="m-auto">{{ numeralFormat(lieferKosten, '0,00[.]00 $') }} </p> -->

                    </div>
                    <!---========-->
                    <div class="flex px-4 py-3 shadow-sm">
                    <p class="w-3/4 my-auto text-warmGray-600 font-semibold ">Gesammt: </p>
                    <!-- <p class="m-auto">{{ numeralFormat(grantTotal, '0,00[.]00 $') }} </p> -->
                    <p class="m-auto">{{ numeralFormat(getTotalCost, '0,00[.]00 $') }} </p>
                   </div>
                  <!---========-->
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      cartTotal: 'getFormCartTotal',
      totalCartItems: 'getTotalCartItems',
      lieferKosten: 'getLieferKosten',
      getTotalCost: 'getGesammtKosten'
    }),
    grantTotal () {
      return this.lieferkosten + this.cartTotal
    }

  },
  methods: {
    ...mapActions({
      setDeleveryCost: 'setDeleveryCost'
    })
  }

}
</script>
